// Utility function to fetch data with AJAX
async function fetchCartData(url, method = "GET", bodyData = null) {
  const options = {
    method: method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  if (bodyData) options.body = JSON.stringify(bodyData);

  const response = await fetch(url, options);
  return await response.json();
}

// Open Cart Drawer Function
function openCartDrawer() {
  const cartDrawer = document.querySelector(".f-cart-drawer");
  if (cartDrawer) {
    cartDrawer.classList.add("f-cart-drawer--active");
  }
  document.body.classList.remove('modal--open', 'modal-quickview--open', 'overflow-hidden');
}

// Close Cart Drawer Function
function closeCartDrawer() {
  const cartDrawer = document.querySelector(".f-cart-drawer");
  if (cartDrawer) {
    cartDrawer.classList.remove("f-cart-drawer--active");
  }
}

// Update Cart Item Count Function
async function updateCartItemCount(count = 0) {
  const cart = await fetchCartData(`${KROWN.settings.routes.cart_url}`);
  const itemCount = count !== 0 ? count : cart.item_count;
  document.querySelectorAll('.cart_number_new').forEach(el => {
    el.textContent = itemCount;
    el.classList.toggle('empty_cart', itemCount <= 0);
  });
}

// Update Cart Drawer Function
async function updateCartDrawer() {
  const res = await fetch(`${KROWN.settings.routes.cart_url}?section_id=unit-drawer`);
  const html = document.createElement("div");
  html.innerHTML = await res.text();
  
  const drawer = document.querySelector('.f-cart-drawer');
  if (drawer && html.querySelector(".f-cart-drawer")) {
    drawer.innerHTML = html.querySelector(".f-cart-drawer").innerHTML;
  }
  
  let isFreeGift = html.querySelector('#only_freegift_cart');
  if (isFreeGift) {
    await updateFreeGift(html); 
  }
}

// Free Gift Logic
async function updateFreeGift(html) {
  let cartItems = html.querySelectorAll('.f-cart-drawer-item');
  let freeGiftDiv = html.querySelector('#only_freegift_cart');
  let freeGiftProduct = freeGiftDiv.getAttribute('data-product');
  let itemFound = freeGiftDiv.getAttribute('data-item-found');
  let itemTotal = freeGiftDiv.getAttribute('data-item-total');
  let freegiftCondition = freeGiftDiv.getAttribute('freegift_condition');
  let freegiftThreshold = freeGiftDiv.getAttribute('freegift_threshold');
  let cartPrice = freeGiftDiv.getAttribute('cart_price');

  if (freegiftCondition && cartPrice && freegiftThreshold && freegiftCondition === 'threshold') {
    cartPrice = parseFloat(cartPrice);
    freegiftThreshold = parseFloat(freegiftThreshold);
    for (const item of cartItems) {
      let cartItemProduct = item.getAttribute('data-product');
      let isFreeGift = item.getAttribute('data-is-freegift');
      let cartItemKey = item.getAttribute('data-line-item-key'); 
      let cartItemPrice = item.getAttribute('data-line-price'); 
      if (cartItemProduct && cartItemKey && cartItemPrice && isFreeGift && freeGiftProduct === cartItemProduct && isFreeGift === 'true') {
        cartItemPrice = parseFloat(cartItemPrice);
        let cartPriceWithoutGift = cartPrice - cartItemPrice;
        if (cartItemPrice > 0 && cartPriceWithoutGift <= freegiftThreshold) {
          const cart = await fetchCartData(`${KROWN.settings.routes.cart_update_url}`, 'POST', { updates: { [cartItemKey]: 0 } });
          await updateCartItemCount(cart.item_count);
          await updateCartDrawer();
          return;
        }
      }
    }
  }
  
  if (!freeGiftProduct && !itemFound && !itemTotal && cartItems.length > 0) {
    return;
  }
  
  if (itemFound < itemTotal) {
    for (const item of cartItems) {
      let cartItemProduct = item.getAttribute('data-product');
      let isFreeGift = item.getAttribute('data-is-freegift');
      let cartItemKey = item.getAttribute('data-line-item-key'); 
      if (cartItemProduct && cartItemKey && isFreeGift && freeGiftProduct === cartItemProduct && isFreeGift === 'true') { 
        const cart = await fetchCartData(`${KROWN.settings.routes.cart_update_url}`, 'POST', { updates: { [cartItemKey]: 0 } });
        await updateCartItemCount(cart.item_count);
        await updateCartDrawer();
        return;
      }
    }
  }
}

/* ==========================================================================
   DELEGATED DRAWER LISTENERS (Bound once at document level)
   ========================================================================== */

document.addEventListener("click", async (e) => {

  // 1. Quantity Selector (+ / -) in Cart Drawer
  const qtyButton = e.target.closest('.f-cart-drawer-quantity-selector button');
  if (qtyButton) {
    const icon = qtyButton.querySelector('.icon');
    const spinner = qtyButton.querySelector('.loading-overlay__spinner');
    if (icon) icon.classList.add('hidden');
    if (spinner) spinner.classList.remove('hidden');

    const rootItem = qtyButton.closest('[data-line-item-key]');
    const key = rootItem?.getAttribute("data-line-item-key");
    const currentQuantity = Number(qtyButton.parentElement.querySelector('input').value);
    const isUp = qtyButton.classList.contains('f-cart-drawer-quantity-selector-plus');
    const newQuantity = isUp ? currentQuantity + 1 : Math.max(currentQuantity - 1, 0);

    if (key) {
      const cart = await fetchCartData(`${KROWN.settings.routes.cart_update_url}`, 'POST', { updates: { [key]: newQuantity } });
      await updateCartItemCount(cart.item_count);
      await updateCartDrawer();
    }

    if (icon) icon.classList.remove('hidden');
    if (spinner) spinner.classList.add('hidden');
    return;
  }

  // 2. Remove Line Item Button in Cart Drawer
  const removeButton = e.target.closest('.f-cart-drawer-item-main-flex-right button');
  if (removeButton) {
    e.preventDefault();
    const rootItem = removeButton.closest('[data-line-item-key]');
    const key = rootItem?.getAttribute("data-line-item-key");

    if (key) {
      const cart = await fetchCartData(`${KROWN.settings.routes.cart_update_url}`, 'POST', { updates: { [key]: 0 } });
      await updateCartItemCount(cart.item_count);
      await updateCartDrawer();
    }
    return;
  }

  // 3. Close Drawer Overlay / Close Button
  if (e.target.closest('.f-cart-drawer-header-right-close') || e.target.classList.contains('f-cart-drawer')) {
    closeCartDrawer();
    return;
  }

  // Prevent closing when clicking inside the main drawer box
  if (e.target.closest('.f-cart-drawer-box')) {
    e.stopPropagation();
  }

  // 4. Cart Icon Trigger
  const cartIcon = e.target.closest('.cart_icon_new');
  if (cartIcon) {
    e.preventDefault();
    await updateCartDrawer();
    openCartDrawer();
    await updateCartItemCount();
    return;
  }

  // 5. Custom Upsell Add-To-Cart inside Drawer
  const customAtcBtn = e.target.closest('.add-to-cart.custom_atc');
  if (customAtcBtn) {
    e.preventDefault();
    customAtcBtn.classList.add('working');

    const form = customAtcBtn.closest('form');
    const key = form?.querySelector('input[name="id"]')?.value;
    if (key) {
      const cart = await fetchCartData(`${KROWN.settings.routes.cart_add_url}`, 'POST', {
        items: [{ id: key, quantity: 1, properties: { '_isGift': true } }]
      });
      await updateCartItemCount(cart.item_count);
      await updateCartDrawer();
    }

    customAtcBtn.classList.remove('working');
    return;
  }

  // 6. Quick Buy Buttons
  const quickBuyBtn = e.target.closest('.quick_buy_on');
  if (quickBuyBtn) {
    e.preventDefault();
    const form = quickBuyBtn.closest('form');
    const loadingSpinner = form?.querySelector('.button__preloader');
    const q_btn = form?.querySelector('.button--loader');

    if (loadingSpinner) q_btn?.classList.add('show_load');

    if (form && form.action.endsWith('/cart/add')) {
      try {
        await fetch(`${KROWN.settings.routes.cart_add_url}`, { method: "POST", body: new FormData(form) });
        await updateCartDrawer();
        await updateCartItemCount();
        openCartDrawer();
      } catch (error) {
        console.error("Error updating cart:", error);
      }

      if (loadingSpinner) q_btn?.classList.remove('show_load');
    }
    return;
  }

  // 7. General Add-To-Cart Buttons
  const generalAtcBtn = e.target.closest('.add-to-cart');
  if (generalAtcBtn && !generalAtcBtn.classList.contains('custom_atc')) {
    e.preventDefault();
    const form = generalAtcBtn.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;

    const loadingSpinner = form.querySelector('.button__preloader');
    const q_btn = form.querySelector('.button--loader');
    if (loadingSpinner && q_btn) {
      q_btn.classList.add('show_load');
    }

    await fetch(`${KROWN.settings.routes.cart_add_url}`, { method: "POST", body: new FormData(form) });
    await updateCartDrawer();
    await updateCartItemCount();
    openCartDrawer();

    if (loadingSpinner && q_btn) { 
      q_btn.classList.remove('show_load');
    }
    return;
  }
});